import { Injectable } from "@angular/core";
import { ContractsService } from "../contracts.service";
import { Web3Service } from "app/services/web3/web3.service";
import { Observable, first, from } from "rxjs";
import { eContracts } from "../contract.config";

@Injectable({
    providedIn: 'root'
})

export class PlaydexService {

    public contract: any

    constructor(
        private contractsService: ContractsService,
        private web3Service: Web3Service
    ) {
        // this.contractsService.setContract(this.web3Service.getWeb3(), eContracts.Playdex);
        // this.contractsService.getContractIstances(eContracts.Playdex).pipe(first()).subscribe(c => this.contract = c);
        this.contract = this.contractsService.getContract( eContracts.Playdex);

    }

    getLenderOffersNumber(collectionAddress: string, lender: string): Observable<any> {
        //lender can be logged account
        return from(this.contract.methods.getLenderOffersNumber(collectionAddress, lender).call());
    }

    getTokenOfLenderByIndex(collectionAddress: string, lender: string, index: number) {
        //lender can be logged account

        return from(this.contract.methods.getTokenOfLenderByIndex(collectionAddress, lender, index).call());
    }

    cancelListing(collectionAddress:string, ownerAddress:string, tokenId:number){
        return from(this.contract.methods.cancelOffer(collectionAddress, tokenId).send({...this.contractsService.additionalParameters(),  from: ownerAddress }));
    }
}